import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireRole } from "@/utils/route-guards";
import { AREA_ROLES } from "@/utils/errandPath";
import { AdminLayout } from "@/components/layout/admin/AdminLayout";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ context, location }) => {
    requireRole(context, location, AREA_ROLES["/admin"]);
  },
  component: AdminAreaLayout,
});

function AdminAreaLayout() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
